export default defineNuxtPlugin(async () => {
  const { getCurrentTenantConfig } = useTenantConfig()
  
  // Initialize tenant configuration on app startup
  try {
    await getCurrentTenantConfig()
  } catch (error) {
    console.error('Failed to initialize tenant configuration:', error)
  }
})
